import type {
  ReportCatalog,
  ReportFrequency,
  ReportSchedule,
  ReportScheduleSubmitPayload,
} from '../types'
import type { ReportScheduleFormValues } from '../types/schemas'

export function formatScheduleDate(value?: string | number | Date | null): string {
  if (value == null || value === '') return '-'
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return '-'
  return new Intl.DateTimeFormat('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  }).format(date)
}

export function toDateInputValue(value?: string | number | Date | null): string {
  if (value == null || value === '') return ''
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function getReportLabel(catalog: ReportCatalog, reportName?: string): string {
  if (!reportName) return '-'
  return catalog[reportName]?.name ?? reportName
}

export function mapScheduleToFormValues(
  schedule: ReportSchedule | null,
): ReportScheduleFormValues {
  return {
    friendly_name: schedule?.friendly_name ?? '',
    report_name: schedule?.report_name ?? '',
    date_range: String(schedule?.date_range ?? ''),
    report_status: schedule?.report_status ?? 'RUNNING',
    frequency: (schedule?.frequency as ReportFrequency | undefined) ?? 'DAILY',
    send_day: schedule?.send_day != null ? String(schedule.send_day) : '',
    send_time: schedule?.send_time ?? '',
    start_date: toDateInputValue(schedule?.start_date),
    fk_company_id: (schedule?.fk_company_id ?? []).map(Number).filter(Number.isFinite),
    listed: '1',
    email_from: schedule?.email_from ?? '',
    email_to: schedule?.email_to ?? '',
    email_cc: schedule?.email_cc ?? '',
    email_bcc: schedule?.email_bcc ?? '',
    reply_to: schedule?.reply_to ?? '',
    email_subject: schedule?.email_subject ?? '',
    email_body: schedule?.email_body ?? '',
  }
}

export function mapFormValuesToPayload(
  values: ReportScheduleFormValues,
): ReportScheduleSubmitPayload {
  const cc = values.email_cc.trim()
  const bcc = values.email_bcc.trim()
  const reply = values.reply_to.trim()

  return {
    friendly_name: values.friendly_name.trim(),
    report_name: values.report_name,
    date_range: values.date_range,
    report_status: values.report_status,
    send_day: values.frequency === 'DAILY' ? null : values.send_day?.trim() || null,
    frequency: values.frequency,
    /** Calendar string only — same scalar Angular sends after `validateData`, not `Date` → ISO UTC. */
    start_date: values.start_date.trim(),
    send_time: values.send_time,
    email_from: values.email_from.trim(),
    email_to: values.email_to.trim(),
    email_cc: cc.length > 0 ? cc : null,
    email_bcc: bcc.length > 0 ? bcc : null,
    reply_to: reply.length > 0 ? reply : null,
    email_subject: values.email_subject.trim(),
    email_body: values.email_body,
    fk_company_id: values.fk_company_id,
  }
}

export function appendUploadedImageHtml(currentHtml: string, imageUrl: string): string {
  const imageHtml = `<p><img src="${imageUrl}" width="150" /></p>`
  return `${currentHtml || ''}${imageHtml}`
}
